import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import {
  getFirestore, collection, doc, setDoc, getDocs,
  query, orderBy, limit, serverTimestamp
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAcrycY6RbXOcs83GDSW3qiKGzTjOwID10",
  authDomain: "focus-gridd.firebaseapp.com",
  projectId: "focus-gridd",
  storageBucket: "focus-gridd.firebasestorage.app",
  messagingSenderId: "835914038641",
  appId: "1:835914038641:web:612faf859886a9ee47cad0",
  measurementId: "G-ZW9EP8ZWSF"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// ─── Auth helpers ──────────────────────────────────────────────────────────────
export async function loginWithGoogle() {
  const result = await signInWithPopup(auth, googleProvider);
  return result.user; // { uid, displayName, email, photoURL }
}

export async function logout() {
  await signOut(auth);
}

// ─── Leaderboard helpers ───────────────────────────────────────────────────────

/**
 * Save score. One doc per user (uid) — always keeps their BEST time.
 */
export async function saveScore(user, result) {
  const ref = doc(db, "leaderboard", user.uid);
  await setDoc(ref, {
    uid: user.uid,
    name: user.displayName,
    avatar: user.displayName.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase(),
    photoURL: user.photoURL || null,
    time: result.time,
    mistakes: result.mistakes,
    steps: result.steps,
    updatedAt: serverTimestamp(),
  }, { merge: false }); // overwrite; caller should only call if new time < old time
}

/**
 * Fetch top 100 by time asc, mistakes asc.
 */
export async function fetchLeaderboard() {
  const q = query(
    collection(db, "leaderboard"),
    orderBy("time", "asc"),
    orderBy("mistakes", "asc"),
    limit(100)
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
